import { render } from "./TrialLimitReachedModal.vue?vue&type=template&id=166bc808&scoped=true"
import script from "./TrialLimitReachedModal.vue?vue&type=script&lang=js"
export * from "./TrialLimitReachedModal.vue?vue&type=script&lang=js"

import "./TrialLimitReachedModal.vue?vue&type=style&index=0&id=166bc808&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166bc808"]])

export default __exports__